<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-btn :disabled="disabled" @click="click()" :id="id" icon v-bind="attrs" v-on="on">
        <v-icon>{{icon}}</v-icon>
      </v-btn>
    </template>
    <span>{{tooltip}}</span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    tooltip: {
      type: String
    },
    icon: {
      type: String
    },
    id: {
      type: String
    },
    disabled: {
      type: Boolean
    }
  },
  methods: {
    click() {
      this.$emit("click");
    }
  }
};
</script>
<style>
#default{
  margin: 2.5px; 
  color: var(--v-gray-darker1);
}
#editTooltip{
  background-color: var(--v-primary-base);
}
</style>